import { AuthService } from 'app/+auth/auth.service';
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { RetailerDto } from "../dtos/retailers.model";
import { ApiResponse, ApiPagedResponse, PaginationInfo } from "../../client-core/api-response-models";
import { ApiService } from "../api.service";
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { StrategicBusinessInitiativeLookupDto, ProgramDto, RetailerLookupDto, BrandLookupDto, BudgetYearLookupDto, SaveProgramCommand, ProgramId, StateLookupDto, CountryLookupDto, CreateProgramShippingLocationCommand, ShippingLocationDto, ProgramDeliveryInformationDto, DeliveryLocationLookupDto, PlanData, ProgramShippingLocationDto } from "../dtos/programs.model";
import { BrandListItemDto } from "../dtos/brands.model";
import { TacticCampaignProgramDescriptionDto, ProgramTacticDto, ProgramTacticCartSummaryDto } from "../dtos/tactics.model";
import { ReplaySubject, Subject } from "rxjs";
import { ProductionProcessingDto } from "../dtos/productionprocessing.model";
import { ShippingDistribution, Tactic } from "../dtos/shipping-distribution.model";
import { ProgramDetailsDto, PromoCodeDto } from '../dtos/program-details';
import { JobsToBeDoneResponse } from '../dtos/jtdb-dto.model';
import { FundingSourceDetailsResult } from '../dtos/funding-details-dto.model';
import { ComponentType } from '../dtos/component-type.model';
import { ActionButtonsDto } from '../dtos/ActionButtonsResponse-dto.model';
import { CommunicationRequestCommentDto, CustomizationMappingFields, NewCommunicationRequestDto } from '../dtos/communication-request.model';
import { CanDeactivateDto } from '../dtos/can-deactivate-dto';
import { CommunicationRequestDto } from '../dtos/communication-request.model';
import { CommunicationRequestInfo } from '../dtos/communication-request.model';
import { CommunicationRequestVersion } from '../dtos/communication-request.model';
import { ProgramCustomization } from '../dtos/program-customization';
import { CustomizationDto, UpdateCustomizationDto } from '../dtos/customization.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ShowHideFinalizeDto, SubmitJobDto } from '../dtos/finalize.model';
import { resolve } from 'url';
import { DropDownItem } from '../dtos/dropdown.models';


@Injectable()
export class ProgramService {
    public programCreated: Subject<ProgramId>;
    public programUpdated: Subject<ProgramId>;
    public programApproved: Subject<ProgramId>;
    public programSubmitted: Subject<ProgramId>;
    public showAddLocationInfo: Subject<ProgramId>;
    public showAddWithDeliveryInfoLocationInfo: Subject<{programId, deliveryDate, deliveryNotes}>;
    public deliveryLocationAdded: Subject<ProgramId>;
    public deliveryLocationSaved: Subject<any>;
    public newProductionProcessingFilesModelArrived: Subject<ProductionProcessingDto>;
    public addressAdded: Subject<ProgramId>;
    public submitProgram: Subject<any>;
    public approveProgram: Subject<any>;
    public fundingsAdded: Subject<any>;
    public newProgramCreated: Subject<ProgramDto>;
    public saveCampaingAndComponents: Subject<{addNew: boolean}>;
    public saveCampaingAndComponentsError: Subject<any>;
    public reloadCommunicationMessages: Subject<any>;
    public shippingLocationUpdated: Subject<any>;
    public shippingLocationSelectionUpdated: Subject<ProgramShippingLocationDto[]>;

    constructor(
        private apiService: ApiService,
        private router: Router,
        private authService: AuthService,
        private httpClient: HttpClient
        ) {
        this.showAddLocationInfo = new Subject<ProgramId>();
        this.showAddWithDeliveryInfoLocationInfo = new Subject<{programId, deliveryDate, deliveryNotes}>();
        this.programCreated = new Subject<ProgramId>();
        this.programUpdated = new Subject<ProgramId>();
        this.programApproved = new Subject<ProgramId>();
        this.programSubmitted = new Subject<ProgramId>();
        this.deliveryLocationSaved = new Subject<any>();
        this.deliveryLocationAdded = new Subject<ProgramId>();
        this.addressAdded = new Subject<ProgramId>();
        this.newProductionProcessingFilesModelArrived = new Subject<ProductionProcessingDto>();
        this.submitProgram = new Subject<any>();
        this.approveProgram = new Subject<any>();
        this.fundingsAdded = new Subject<any>();
        this.newProgramCreated = new Subject<ProgramDto>();
        this.saveCampaingAndComponents = new Subject<any>();
        this.saveCampaingAndComponentsError = new Subject<any>();
        this.reloadCommunicationMessages = new Subject<any>();
        this.shippingLocationUpdated = new Subject<any>();
        this.shippingLocationSelectionUpdated = new Subject<ProgramShippingLocationDto[]>();
    }

    getProgram(id: number): Observable<ApiResponse<ProgramDto>> {
        console.log(`>>getProgram for ${id}`);
        return this.apiService.get<ProgramDto>(`programs/${id}`);
    }
    getProgramDetailsFor(id: number): Observable<ApiResponse<TacticCampaignProgramDescriptionDto>> {
        console.log(`>>getProgramDetails for ${id}`);
        return this.apiService.get<TacticCampaignProgramDescriptionDto>(`programs/${id}/programdetails`);
    }
    getRetailersLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<RetailerLookupDto>>> {
        console.log('>>getRetailersLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<RetailerLookupDto>>('programs/lookup/retailer', params);
    }
    getStrategicBusinessInitiativeLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<StrategicBusinessInitiativeLookupDto>>> {
        console.log('>>getStrategicBusinessInitiativeLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<StrategicBusinessInitiativeLookupDto>>('programs/lookup/strategic-business-initiative', params);
    }
    getExecStatusLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<StrategicBusinessInitiativeLookupDto>>> {
        return this.apiService.get<ApiPagedResponse<StrategicBusinessInitiativeLookupDto>>('programs/lookup-exec-status', params);
    }
    getBrandsLookup(fiscalYear:number): Observable<ApiResponse<ApiPagedResponse<BrandLookupDto>>> {
        console.log('>>getBrandsLookup', fiscalYear);
        let params = { budgetYearId: fiscalYear, pageSize: 100000, pageIndex: 0 };
        return this.apiService.get<ApiPagedResponse<BrandLookupDto>>('programs/lookup/brand', params);
    }

    getBudgetYearsLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<BudgetYearLookupDto>>> {
        console.log('>>getBudgetYearsLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<BudgetYearLookupDto>>('programs/lookup/budget-year', params);
    }

    createProgram(command: SaveProgramCommand): Observable<ApiResponse<ProgramId>> {
        return this.apiService.post<ProgramId>('programs', command);
    }

    createNewProgram(command: ProgramDto): Observable<ApiResponse<ProgramId>> {
        return this.apiService.post<ProgramId>('programs/create-new-program', command);
    }

    updateProgram(id: number, command: SaveProgramCommand): Observable<ApiResponse<ProgramId>> {
        return this.apiService.post<ProgramId>(`programs/${id}`, command);
    }

    getStatesLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<StateLookupDto>>> {
        console.log('>>getStatesLookupDto', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<StateLookupDto>>('programdelivery/lookup/state', params);
    }

    getCountriesLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<CountryLookupDto>>> {
        console.log('>>getCountriesLookup', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<CountryLookupDto>>('programdelivery/lookup/country', params);
    }

    createProgramShippingLocation(shippingLocationDto: ShippingLocationDto): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`shippinglocation/${shippingLocationDto.programid || 0}`, shippingLocationDto);
    }

    getProgramDeliveryInformation(id: number): Observable<ApiResponse<ProgramDeliveryInformationDto>> {
        console.log(`>>getProgramDeliveryLocations for ${id}`);
        return this.apiService.get<ProgramDeliveryInformationDto>(`programs/${id}/deliveryinformation`);
    }

    getDeliveryLocationLookup(
        id: number, 
        contactType?: string, 
        retailerId?: number,
        accountLocationId?: number,
        contactTypeSecondaryType?: string,
        openSearch?: string,
        suppressEmailContact?: any,
        generateEmailReadyCopy?: any,
        dropdownSearch?: string,
        selectAll: number = 0,
        extraParams = {}
    ): Observable<ApiResponse<ApiPagedResponse<DeliveryLocationLookupDto>>> {
        const queryparams = {
            programId: id,
            contactType,
            retailerId,
            accountLocationId,
            contactTypeSecondaryType,
            openSearch,
            suppressEmailContact,
            generateEmailReadyCopy,
            dropdownSearch,
            selectAll
        }
        const queryString = [];
        for (const p in queryparams) {
            queryString.push( `${p}=${queryparams[p]}`);
        }
        return this.apiService.post<ApiPagedResponse<DeliveryLocationLookupDto>>(`programs/deliverylocations?${queryString.join('&')}`, extraParams);
    }

    saveDeliveryInformation(id: number, deliveryInformationDto: ApiResponse<ProgramDeliveryInformationDto>): Observable<ApiResponse<number>> {
        let locations = [];
        const { deliveryDate = "", deliveryNotes = "", programShippingLocation = [] } = deliveryInformationDto.data;
        if (programShippingLocation && programShippingLocation.length) {
            locations = programShippingLocation.map(pl => pl.deliveryLocationId);
        }

        return this.apiService.put<number>(`programs/${id}/deliveryinformation`, {
            locations: locations.join(`,`),
            deliveryNotes,
            deliveryDate
        });
    }

    approve(id: number): Observable<ApiResponse<number>> {
        console.log(`>>approve for program Id ${id}`);
        return this.apiService.get<number>(`programs/${id}/approval`);
    }

    submit(id: number): Observable<ApiResponse<number>> {
        console.log(`>>submit for program Id ${id}`);
        return this.apiService.get<number>(`programs/${id}/submission`);
    }
    getProductionProcessingFiles(params?: any): Observable<ApiResponse<ApiPagedResponse<ProductionProcessingDto>>> {
        console.log('>>getProductionProcessingFiles', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<ProductionProcessingDto>>('programs/productionfiles', params);
    }

    getJobTicketFile(programID: Number): void {
        window.open(this.apiService.getApiUrlFor(`programs/${programID}/getfile`), '_target');
        // return this.apiService.get<ApiPagedResponse<ProductionProcessingDto>>(`programs/${programID}/getfile`);
    }

    getManufacturers(programid?: number): Observable<any> {
        return this.apiService.get<any>(`programs/${programid}/getmanufacturers`);
    }

    getAllManufacturers(programs?: Array<number>): Observable<any> {
        return this.apiService.get<any>(`programs/getallmanufacturers${this.getQueryStringFromArray(programs)}`);
    }

    getInventoryManufacturers(programid?: number): Observable<any> {
        return this.apiService.get<any>(`programs/${programid}/getinventorymanufacturers`);
    }

    getAllInventoryManufacturers(programs?: Array<number>): Observable<any> {
        return this.apiService.get<any>(`programs/get-all-inventorymanufacturers${this.getQueryStringFromArray(programs)}`);
    }

    getJobTicketFileByManufacturer(programID: Number, manufacturerid: number): void {
        console.log(`programs/${programID}/${manufacturerid}/getfile`);
        // tslint:disable-next-line:max-line-length
        window.open(this.apiService.getApiUrlFor(`programs/${programID}/${manufacturerid}/getfile?sitename=${this.authService.getSiteName()}`), '_blank');
        // return this.apiService.get<ApiPagedResponse<ProductionProcessingDto>>(`programs/${programID}/getfile`);
    }

    getAllJobTicketFileByManufacturer(programs: Array<number>, manufacturerid: number): void {
        console.log(`programs/${manufacturerid}/getallfile`);
        // tslint:disable-next-line:max-line-length
        window.open(this.apiService.getApiUrlFor(`programs/${manufacturerid}/getallfile${this.getQueryStringFromArray(programs)}&sitename=${this.authService.getSiteName()}`), '_blank');
    }

    getInventoryJobTicketFileByManufacturer(programID: Number, manufacturerid: number): void {
        console.log(`programs/${programID}/${manufacturerid}/getinventoryJobTicket`);
        // tslint:disable-next-line:max-line-length
        window.open(this.apiService.getApiUrlFor(`programs/${programID}/${manufacturerid}/getinventoryJobTicket?sitename=${this.authService.getSiteName()}`), '_blank');
        // return this.apiService.get<ApiPagedResponse<ProductionProcessingDto>>(`programs/${programID}/getfile`);
    }

    getAllInventoryJobTicketFileByManufacturer(programs: Array<number>, manufacturerid: number): void {
        console.log(`programs/${manufacturerid}/get-all-inventoryJobTicket`);
        // tslint:disable-next-line:max-line-length
        window.open(this.apiService.getApiUrlFor(`programs/${manufacturerid}/get-all-inventoryJobTicket${this.getQueryStringFromArray(programs)}&sitename=${this.authService.getSiteName()}`), '_blank');
        // return this.apiService.get<ApiPagedResponse<ProductionProcessingDto>>(`programs/${programs}/getfile`);
    }

    storeProductionProcessingRquestLog(programId: number): Observable<any> {
        console.log('>>productionprocessingrequest', programId);
        return this.apiService.post<any>(`programs/productionprocessingrequest/${programId}`, {});
    }

    storeAllProductionProcessingRquestLog(programs: Array<number>): Observable<any> {
        console.log('>>productionprocessingrequest', programs);
        return this.apiService.post<any>(`programs/productionprocessingrequest-all`, {
            programs: programs
        });
    }

    transferFiles(): Observable<any> {
        console.log('>>transferFiles');
        return this.apiService.post<any>(`programs/transfer-files`, {});
    }

    getDistributionLocation(programID: Number, searchTerm?: string, page?: number): Observable<any> {
        return this.apiService.get<any>(`programs/shippinglocation/${programID}?searchTerm=${searchTerm}&pageIndex=${page}`);
    }

    saveShippingLocationDistribution(programID: number, params: Array<Tactic>) {
        return this.apiService.put(`programs/saveshippinglocation/${programID}`, params)
    }

    getQueryStringFromArray(programs: Array<number>) {
        let programsString = '?';
        programs.forEach(p => {
            programsString += `programs=${p}&`;
        });
        programsString = programsString.substr(0, programsString.length - 1);
        return programsString;
    }

    getTemplate(): void {
        window.open(this.apiService.getApiUrlFor(`programs/download-import-template?sitename=${this.authService.getSiteName()}`), '_blank');
        // return this.apiService.get<ApiPagedResponse<ProductionProcessingDto>>(`programs/${programID}/getfile`);
    }

    getFileTemplate(filename, filetype = "text/csv"): void {
        window.open(this.apiService.getApiUrlFor(`programs/get-file?filename=${filename}&filetype=${filetype}`), '_blank');
        // return this.apiService.get<ApiPagedResponse<ProductionProcessingDto>>(`programs/${programID}/getfile`);
    }

    getCommunicationFile(key): void {
        window.open(this.apiService.getApiUrlFor(`programs/communicationrequest/file?key=${key}`), '_blank');
        // return this.apiService.get<ApiPagedResponse<ProductionProcessingDto>>(`programs/${programID}/getfile`);
    }

    saveCopy(id: number, command: SaveProgramCommand): Observable<ApiResponse<ProgramId>> {
        return this.apiService.post<ProgramId>(`programs/${id}/save-copy`, command);
    }

    createPrefilledProgram(campaignThemeId: number): Observable<ApiResponse<ProgramId>> {
        return this.apiService.post<ProgramId>(`programs/prefill/${campaignThemeId}`, {});
    }

    getAccountLocations(programID: Number): Observable<any> {
        return this.apiService.get<any>(`programs/account-locations/${programID}`);
    }

    saveAccountLocation(accountLocations: Array<number>, programId: number): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/${programId}/add-account-location`, {
            accountLocations: accountLocations,
            programId: programId
        });
    }

    getProgramDetails(id: number, promocodeRequired: boolean): Observable<ApiResponse<ProgramDetailsDto>> {
        console.log(`>>getProgram for ${id}`);
        return this.apiService.get<ProgramDetailsDto>(`programs/details-view/${id}?promocodeRequired=${promocodeRequired}`);
    }

    getProgramFundings(id: number): Observable<ApiResponse<any>> {
        console.log(`>>getProgram for ${id}`);
        return this.apiService.get<any>(`programs/program-fundings/${id}`);
    }

    saveProgramPromo(model: PromoCodeDto): Observable<ApiResponse<any>> {
        return this.apiService.post(`programs/save-program-promo`, model);
    }

    getPromoCode(id: number): Observable<ApiResponse<PromoCodeDto>> {
        return this.apiService.get<PromoCodeDto>(`programs/program-promo/${id}`);
    }

    getBudgetTypes(): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programs/budget-types`);
    }

    getFundingSourcesView(params): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programs/funding-sources`, params);
    }

    saveFundingSources(programId, sorces): Observable<ApiResponse<any>> {
        return this.apiService.post(`programs/${programId}/save-funding-sources`, {
            fundings: sorces
        });
    }

    getFundingSourcesEditView(id, brandId): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programs/funding-sources/${id}?brandId=${brandId}`, {});
    }

    saveFundingSourcesEdit(sources, participants): Observable<ApiResponse<any>> {
        return this.apiService.post(`programs/funding-sources`, {
            itens: sources,
            participants: participants
        });
    }

    saveNewProgramDetails(dto: ProgramDetailsDto): Observable<ApiResponse<boolean>> {
        return this.apiService.put<boolean>('programs/update-new-details', dto);
    }

    deletePromocode(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.delete<boolean>(`programs/delete-promocode/${id}`);
    }

    submitProgramForApproval(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/submit`, {});
    }

    cancel(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/cancel`, {});
    }

    saveApproveProgram(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/approve`, {});
    }

    close(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/close`, {});
    }

    revise(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/revise`, {});
    }

    approvePromocode(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/approve-promocode`, {});
    }

    submitPromocode(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/submit-promocode`, {});
    }

    rejectPromocode(id: number, notes: string): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/reject-promocode`, {
            notes
        });
    }

    approvePromocodeTier2(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/approve-promocode-tier2`, {});
    }

    rejectProgram(id: number, notes: string): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/reject-program`, {
            notes
        });
    }

    copyProgram(model): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/copy`, model);
    }

    reviseProgram(programId): Observable<ApiResponse<boolean>> {
        return this.apiService.put<boolean>(`programs/${programId}/revise`, {});
    }

    sendMessage(dto): Observable<any> {
        return this.apiService.post<any>(`programs/send-message`, dto);
    }

    getHasCustomizations(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.get<boolean>(`programs/has-customizations/${id}`);
    }

    getHasCustomizationEntries(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.get<boolean>(`programs/has-customization-entries/${id}`);
    }

    saveRetailer(programId, retailerId): Observable<any> {
        return this.apiService.post<any>(`programs/update-retailer/${programId}?retailerId=${retailerId}`, {});
    }

    saveDeliveryDate(deliveryDate: string, programId: number): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/${programId}/update-delivery-date`, {
            deliveryDate,
            programId
        });
    }

    checkCanDeleteProgram(id: number): Observable<ApiResponse<{programId: number, canDelete: string}>> {
        return this.apiService.get<{programId: number, canDelete: string}>(`programs/check-candelete/${id}`, {});
    }

    checkCanDeactivateProgram(id: number): Observable<ApiResponse<CanDeactivateDto>> {
        return this.apiService.get<CanDeactivateDto>(`programs/check-candeactivate/${id}`, {});
    }

    deleteProgramFromDatabase(id: number): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/delete-program/${id}`, {});
    }

    checkCanSubmitToApproval(id: number): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`programs/can-submit/${id}`);
    }

    getJobsToBeDoneDetails(jobstobedoneheaderids: string, programId?: number): Observable<ApiResponse<JobsToBeDoneResponse>> {
        return this.apiService.get<JobsToBeDoneResponse>(`programs/jobstobedonedetails?jobstobedoneheaderids=${jobstobedoneheaderids}&programId=${programId || ''}`);
    }

    saveJobsToBeDoneDetails(model: JobsToBeDoneResponse): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/jobstobedonedetails`, model);
    }

    getProgramFundingDetails(programId?: number): Observable<ApiResponse<FundingSourceDetailsResult>> {
        return this.apiService.get<FundingSourceDetailsResult>(`programs/funding-sources-details?programId=${programId}`);
    }

    addFundingSource(programId: number, fund: PlanData): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${programId}/add-fund`, fund);
    }

    removeFundingSource(fund: number): Observable<ApiResponse<boolean>> {
        return this.apiService.delete<boolean>(`programs/remove-fund/${fund}`);
    }

    saveProgramTacticAndComponent(id, model): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programtactics/save-programtactic-and-component/${id}`, model);
    }

    getProgramComponentTypes(programId?: number, taticId?: number, componentId?: number, programTacticId?: number): Observable<ApiResponse<Array<ComponentType>>> {
        return this.apiService.get<Array<ComponentType>>(`programs/${programId}/component-types?taticId=${taticId}&programTacticComponentId=${componentId}&programTacticId=${programTacticId}`);
    }

    getActionButtons(programId, programPromocodeId?): Observable<ApiResponse<ActionButtonsDto[]>> {
        return this.apiService.get<ActionButtonsDto[]>(`programs/program-promo/action-buttons`, {
            programId,
            programPromocodeId
        });
    }

    execActionButton(programPromoCodeId?, action="Default", programId?): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/program-promo/action-buttons`, {
            action,
            programPromoCodeId,
            programId
        });
    }

    getProgramsLookup(params?: any): Observable<ApiResponse<ApiPagedResponse<{id, name}>>> {
        return this.apiService.get<ApiPagedResponse<{id, name}>>('programs/lookup/programs', params);
    }

    getReasonsForReview(params?: any): Observable<ApiResponse<{id, name, selected: boolean}[]>> {
        return this.apiService.get<{id, name, selected: boolean}[]>('programs/reason-for-review', params);
    }

    getRelatedPrograms(params?: any): Observable<ApiResponse<{id, name, selected: boolean}[]>> {
        return this.apiService.get<{id, name, selected: boolean}[]>('programs/related-programs', params);
    }

    getContacts(params?: any): Observable<ApiResponse<ApiPagedResponse<{id, name}>>> {
        return this.apiService.get<ApiPagedResponse<{id, name}>>('programs/lookup/contacts', params);
    }

    saveNewCommunicationRequest(params: NewCommunicationRequestDto): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/add-communicationrequest`, params);
    }

    deactivateProgram(id: number): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/de-activate/${id}`, {});
    }

    programExists(id: number): Observable<ApiResponse<{programExists: boolean, displayMessage: string}>> {
        return this.apiService.get<{programExists: boolean, displayMessage: string}>(`programs/exists/${id}`, {});
    }

    getCommunicationRequest(params?: any): Observable<ApiResponse<ApiPagedResponse<CommunicationRequestDto>>> {
        return this.apiService.get<ApiPagedResponse<CommunicationRequestDto>>('programs/communicationrequest', params);
    }

    getCommunicationRequestInfo(id: number): Observable<ApiResponse<CommunicationRequestInfo>> {
        return this.apiService.get<CommunicationRequestInfo>(`programs/communicationrequest/${id}`, {});
    }

    getCommunicationRequestVersion(id: number, versionId: number): Observable<ApiResponse<CommunicationRequestVersion>> {
        return this.apiService.get<CommunicationRequestVersion>(`programs/communicationrequest/${id}/${versionId}`, {});
    }

    addCommunicationRequestComment(params: CommunicationRequestCommentDto): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/communicationrequest/add-comment`, params);
    }

    updateReasonForReview(params: any): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/communicationrequest/update-reason-review`, params);
    }

    updateRelatedTactics(params: any): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/communicationrequest/update-related-tactics`, params);
    }

    updateContacts(params: any): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/communicationrequest/update-contacts`, params);
    }

    addNewVersion(params: any): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/communicationrequest/add-version`, params);
    }

    markCommunicationAsResolved(params: any): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/communicationrequest/mark-as-resolved`, params);
    }

    getProgramStatusConfig(tab, retailerId): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiService.get<any>(`programs/status-config`, {
                tab,
                retailerId
            }).subscribe(res => {
                resolve(res.data);
            })
        });
    }

    getProgramStatusList(model): Observable<any> {
        return this.apiService.get<any>(`programs/status-list`, model);
    }

    downloadProgramStatusReport(params?: any) {
        const httpOptions = {
            responseType: "blob",
            headers: new HttpHeaders({ 'Content-Type': 'application/json' })
        };
        return this.apiService.post<any>(`programs/status-list-export?pageNumber=${params.pageNumber}&brandIds=${params.brandIds}&retailerIds=${params.retailerIds}&startDate=${params.startDate}&endDate=${params.endDate}&showHidden=${params.showHidden}&orderBy=${params.orderBy}&sortDirection=${params.sortDirection}`, params, httpOptions);
    }

    saveDynamicTable(data: any): Observable<ApiResponse<number>> {
        return this.apiService.post<number>(`programs/save-dynamic-table`, data);
    }

    programCustomizations(programId): Promise<ApiResponse<ApiPagedResponse<ProgramCustomization>>> {
        return new Promise<ApiResponse<ApiPagedResponse<ProgramCustomization>>>((resolve, reject) => {
            this.apiService.get<any>(`programs/${programId}/customizations`, {}).subscribe(res => {
                resolve(res.data);
            })
        });
    }

    updateProgramCustomizations(programId: number, data: UpdateCustomizationDto): Observable<ApiResponse<any>> {
        return this.apiService.put<any>(`programs/${programId}/customizations`, data);
    }

    programApplyCustomizations(programId: number): Observable<ApiResponse<string>> {
        return this.apiService.put<string>(`programs/${programId}/apply-customizations`, {});
    }

    getMentions(): Observable<ApiResponse<{id: number, name: string}[]>> {
        return this.apiService.get<{id: number, name: string}[]>(`programs/mentions`, {});
    }

    createNewAdditionalPrograms(params): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>('programs/crete-new-additionl', params);
    }

    getUnits(params): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>(`programs/unit-dropdown`, params);
    }

    getShippingLocationToEdit(id): Observable<ApiResponse<ShippingLocationDto>> {
        return this.apiService.get<ShippingLocationDto>(`programs/shipping-location/${id}`, {});
    }

    updateShippingLocation(params): Observable<ApiResponse<ShippingLocationDto>> {
        return this.apiService.post<ShippingLocationDto>(`programs/shipping-location/${params.id}`, params);
    }

    getAddressBook(params): Observable<any> {
        return this.apiService.get<any>(`programs/addressbook`, params);
    }

    requestCouponCode(params): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/request-coupon-code`, params);
    }

    AddRemoveShippingLocation(params): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`programs/add-remove-shippinglocation`, params);
    }

    getShowHideFinalize(id): Observable<ApiResponse<ShowHideFinalizeDto[]>> {
        return this.apiService.get<any>(`programs/${id}/show-hide-finalize`, {});
    }

    getSubmitJob(id, onload): Observable<ApiResponse<SubmitJobDto>> {
        return this.apiService.get<SubmitJobDto>(`programs/${id}/submit-job?onload=${onload}`, {});
    }

    getCustomizationFields(programTacticId, customizationRequestId): Observable<ApiResponse<CustomizationMappingFields[]>> {
        return this.apiService.get<CustomizationMappingFields[]>(`programs/${programTacticId}/customizations/file-fields-map?customizationRequestId=${customizationRequestId}`, {});
    }

    programApplyProductionCustomizations(programId: number): Promise<ApiResponse<string>> {
        return new Promise((resolve, reject) => {
            this.apiService.put<string>(`programs/${programId}/apply-customizations-production`, {}).subscribe(res => {
                resolve(res);
            }, error => {
                reject(error);
            });
        })
    }

    programApplyProductionProofCustomizations(programId: number, programShippingLocationId: number): Promise<ApiResponse<string>> {
        return new Promise((resolve, reject) => {
            this.apiService.put<string>(`programs/${programId}/apply-customizations-shippinglocationproof?programShippingLocationId=${programShippingLocationId}`, {}).subscribe(res => {
                resolve(res);
            }, error => {
                reject(error);
            });
        })
    }

    getConcatonate(id, programShippingLocationId?: number, programShippingLocationRun?: number): Observable<ApiResponse<SubmitJobDto>> {
        return this.apiService.get<SubmitJobDto>(`programs/${id}/concatonate`, {
            programShippingLocationId,
            programShippingLocationRun
        });
    }

    putConcatonate(params): Observable<any> {
        return this.apiService.post('programs/send-concatonate', params);
    }

    getDropdownFilters(id, campaignThemeId?: number, retailerId?: number): Observable<ApiResponse<ApiPagedResponse<DropDownItem>>> {
        return this.apiService.get<ApiPagedResponse<DropDownItem>>(`programs/${id}/filters-dropdown-list?campaignThemeId=${campaignThemeId || 0}&retailerId=${retailerId || 0}`, {});
    }

    closeComponent(programTacticComponentId): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/close-programtacticcomponent?programTacticComponentId=${programTacticComponentId}`, {});
    }

    markProgramAsCompleted(id): Observable<ApiResponse<boolean>> {
        return this.apiService.post<boolean>(`programs/${id}/mark-as-completed`, {});
    }

    getProofUrl(id, programShippingLocationId?: number): Observable<ApiResponse<{url: string}>> {
        return this.apiService.get<{url: string}>(`programs/${id}/get-proof-url`, {
            programShippingLocationId
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/program.service.ts